module["exports"] = [
  "com",
  "biz",
  "info",
  "name",
  "net",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/internet/domain_suffix.js
// module id = 1049
// module chunks = 0